import * as React from "react";
const WorkshopTimeIconMoblie = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={12}
    fill="none"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.125}
      d="M7.063 7.438 5.938 5.75V2.937M.875 5.75A5.063 5.063 0 1 0 11 5.75a5.063 5.063 0 0 0-10.125 0Z"
    />
  </svg>
);
export default WorkshopTimeIconMoblie;
